/**
 * Created by adam.clarke on 19/09/2016.
 */

var admin = {
    events: [],

    registerLoad: function(event) {
        this.events.push(event);
    },

    loaded: function(prefix) {
        if (prefix != "") prefix = prefix + " ";

        this.events.forEach(function (event) {
            event(prefix);
        })
    },

    showError: function (errors) {
        var message = "";
        errors.forEach(function (error)
        {
           message = message + error.message + "\n";
        });

        swal({
            title: "Error",
            text: message,
            type: "error",
            showCancelButton: false,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "OK",
            closeOnConfirm: true
        });
    }
};

admin.registerLoad(function (prefix) {
    $(prefix + ".js-image-modal").on("click", function(ev) {
        ev.preventDefault();
        $('#imagepreview').attr('src', $(this).attr('href')); // here asign the image to the modal when the user click the enlarge link
        $('#imagemodal').modal('show'); // imagemodal is the id attribute assigned to the bootstrap modal, then i use the show function
    });

    // make any select options listed in to html so things like icons show in chosed dropdowns
    $(prefix + '.js-chosen-html').each(function () {
        $(this).find("option").each(function () {
            var html = $(this).text();
            $(this).html(html);
        });
    });

    $(prefix + '.chosen-select').chosen({width: "100%"}).on("chosen:showing_dropdown", function (ev) {
        $(this).next().find(".chosen-drop").hide();
        var top = $(this).parent().offset().top;
        var doc = $(document).height();
        if (top + 300 > doc) {
            $(this).next().find(".chosen-drop").addClass("chosen-drop-up");
        } else {
            $(this).next().find(".chosen-drop").removeClass("chosen-drop-up");
        }
        $(this).next().find(".chosen-drop").show();
    });

    $(document).delegate('*[data-toggle="lightbox"]', 'click', function(event) {
        event.preventDefault();
        $(this).ekkoLightbox();
    });

    $(prefix + '.clockpicker').clockpicker({
        placement: 'bottom', // clock popover placement
        align: 'left',       // popover arrow align
        donetext: '',    // done button text
        autoclose: true,    // auto close when minute is selected
        twelvehour: true, // change to 12 hour AM/PM clock from 24 hour
        vibrate: true        // vibrate the device when dragging clock hand
    });

    $(prefix + 'table.js-float-thread').floatThead();

    $(prefix + '.js-type-update').each(function () {
        var container_id = $(this).data('container-id');
        var field_id = $(this).data('field-id');
        var params_url = $(this).data('params-url');
        var wait = $(this).parent().children(".please_wait");

        $(field_id).change(function () {
            var value = $(this).val();
            url = params_url.replace("XXXXXXXX", value);
            wait.show();
            $(container_id).load(url, function () {
                wait.hide();
                admin.loaded(container_id);
            });
        });
    });

    $(prefix + '[data-toggle="tooltip"]').tooltip();

    $(prefix + '.js-date-range').each(function () {
        var $this = $(this);
        var cancelLabel = "Cancel";
        var autoUpdateInput = true;

        if ($this.data("filter-optional") == "1")
        {
            cancelLabel = "Clear";
            autoUpdateInput = false;
        }

        $this.daterangepicker({
            alwaysShowCalendars: true,
            autoUpdateInput: autoUpdateInput, // stop automatic update so we can clear the input
            locale: {
                format: 'DD/MM/YYYY',
                cancelLabel: cancelLabel
            },
            ranges: {
                'Last Week': [moment().subtract(7, 'days').startOf('week').add(1, 'days'), moment().subtract(7, 'days').endOf('week').add(1, 'days')],
                'This Week': [moment().startOf('week').add(1, 'days'), moment().endOf('week').add(1, 'days')],
                'Next Week': [moment().add(7, 'days').startOf('week').add(1, 'days'), moment().add(7, 'days').endOf('week').add(1, 'days')],
                'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                'This Month': [moment().startOf('month'), moment().endOf('month')],
                'Next Month': [moment().add(1, 'month').startOf('month'), moment().add(1, 'month').endOf('month')]
            }
        });

        var current = $(this).val();

        // fill in the date on select
        if (!autoUpdateInput) {
            $this.on('apply.daterangepicker', function (ev, picker) {
                $(this).val(picker.startDate.format('DD/MM/YYYY') + ' - ' + picker.endDate.format('DD/MM/YYYY'));
                if ($(this).val() != current) {
                    applyFilter();
                }
            });

            // clear on cancel
            $this.on('cancel.daterangepicker', function (ev, picker) {
                $(this).val('');
                if ($(this).val() != current) {
                    applyFilter();
                }
            });
        } else {
            $this.on('apply.daterangepicker', function (ev, picker) {
                if ($(this).val() != current) {
                    applyFilter();
                }
            });
        }
    });
});

$(document).ready(function () {
    admin.loaded("body");
});